// extracted by mini-css-extract-plugin
var _1 = "MultiValuedListItem-moduleMultiValuedListItem__IhIDF";
var _2 = "MultiValuedListItem-modulelarge__HJqJO";
var _3 = "MultiValuedListItem-modulemedium__afmfs";
var _4 = "MultiValuedListItem-modulesingle__iZ78T";
var _5 = "MultiValuedListItem-modulesmall__IGZYK";
var _6 = "MultiValuedListItem-moduletag__Rqmg3";
var _7 = "MultiValuedListItem-moduleunread__P3hVu";
var _8 = "MultiValuedListItem-modulex-large__oWMrf";
var _9 = "MultiValuedListItem-modulex-small__U5pYX";
export { _1 as "MultiValuedListItem", _2 as "large", _3 as "medium", _4 as "single", _5 as "small", _6 as "tag", _7 as "unread", _8 as "x-large", _9 as "x-small" }
